/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import cx from 'classnames';
import { useTheme, useOverflow, useMergedRefs } from '../utils/index.js';
import SelectTag from './SelectTag.js';
/**
 */
export const SelectTagContainer = React.forwardRef((props, ref) => {
    const { tags, className, ...rest } = props;
    useTheme();
    const [containerRef, visibleCount] = useOverflow(tags);
    const refs = useMergedRefs(ref, containerRef);
    return (React.createElement("div", { className: cx('iui-select-tag-container', className), ref: refs, ...rest },
        React.createElement(React.Fragment, null,
            visibleCount < tags.length ? tags.slice(0, visibleCount - 1) : tags,
            visibleCount < tags.length && (React.createElement(SelectTag, { label: `+${tags.length - visibleCount + 1} item(s)` })))));
});
export default SelectTagContainer;
